export const translations = {
  EN: {
    'nav.home': 'Home',
    'nav.tours': 'Tours',
    'nav.cooperation': 'Cooperation',
    'nav.contact': 'Contact',
    'nav.about': 'About us',
    'nav.back': 'Back',
    'nav.label': 'Primary navigation',
    'nav.footerLabel': 'Footer navigation',
    'nav.openMenu': 'Open navigation menu',
    'nav.closeMenu': 'Close navigation menu',
    'brand.tagline': 'Travel blog',
    'language.label': 'Language',
    'home.heroEyebrow': 'Travel stories & guides',
    'home.heroTitle': 'Beyond the usual paths.',
    'home.heroDescription': 'Discover our journeys, explore new places and find inspiration for your next adventure.',
    'home.exploreJourneys': 'Explore our journeys',
    'home.continentsTitle': 'Explore by Continent',
    'home.continentsDescription': 'Discover stories and adventures from every corner of the world.',
    'home.featuredTitle': 'Featured Journeys',
    'home.featuredDescription': 'A few journeys worth remembering.',
    'home.featuredLoading': 'Loading journeys...',
    'home.featuredError': 'Featured journeys could not be loaded. Please try again later.',
    'home.featuredEmpty': 'No journeys are available yet.',
    'home.mapTitle': 'Explore Our World',
    'home.mapDescription': 'Every red dot marks a country we have explored. Choose a destination to discover its stories.',
    'home.viewCountryPosts': 'View stories',
    'home.recentPosts': 'Recent posts',
    'home.recentPostsError': 'Recent posts could not be loaded. Please try again later.',
    'home.scrollRecentPosts': 'Scroll to see more posts',
    'home.scrollRecentPostsBack': 'Scroll to see previous posts',
    'home.aboutTitle': 'The Story Behind Deer On Tour',
    'home.aboutDescription': 'We share the places we discover, the journeys we take and the stories that make every destination memorable.',
    'home.aboutImageAlt': 'A landscape from one of our journeys',
    'home.aboutLink': 'More about us',
    'posts.countryTitle': 'Postsss from',
    'posts.loading': 'Loading posts...',
    'posts.loadError': 'Error loading posts:',
    'posts.noCountry': 'No country provided.',
    'posts.none': 'No posts found for this country.',
    'tours.byContinents': 'Our tours by continent',
    'tours.heroEyebrow': 'Find your next journey',
    'tours.heroDescription': 'Explore destinations, discover our travel stories and find inspiration for your next adventure.',
    'tours.discoverEyebrow': 'Choose your destination',
    'tours.continentsDescription': 'Browse our journeys by continent and find stories from the places we have explored.',
    'tours.storyCountOne': 'story',
    'tours.storyCountFew': 'stories',
    'tours.storyCount': 'stories',
    'tours.popularEyebrow': 'Travel inspiration',
    'tours.popularTitle': 'Popular tours',
    'tours.popularDescription': 'Discover memorable journeys and get inspired for your own trip.',
    'tours.days': 'days',
    'tours.noPopularTours': 'No tours are available yet.',
    'tours.plannerEyebrow': 'Your next adventure',
    'tours.plannerTitle': 'Ready to plan your next journey?',
    'tours.plannerDescription': 'Get in touch with us and let us help you find inspiration for your next trip.',
    'tours.plannerAction': 'Get in touch',
    'continent.africa': 'Africa',
    'continent.asia': 'Asia',
    'continent.europe': 'Europe',
    'continent.north america': 'North America',
    'continent.south america': 'South America',
    'continent.australia': 'Australia',
    'continent.oceania': 'Oceania',
    'continent.antarctica': 'Antarctica',
    'tours.chooseCountry': 'Choose posts by country',
    'tours.allCountries': 'All countries',
    'tours.postsFrom': 'Posts from',
    'tours.noContinent': 'No continent provided',
    'tours.flag': 'Flag of',
    'tours.loading': 'Loading tours...',
    'tours.loadError': 'Error loading tours:',
    'tours.noCountries': 'No countries found for this continent.',
    'tours.noSelectedTours': 'No tours found for the selected countries.',
    'tours.noTours': 'No tours found for this continent.',
    'post.travelStory': 'Travel story',
    'post.by': 'by',
    'post.tripDetails': 'Trip details',
    'post.gallery': 'Gallery',
    'post.duration': 'Duration',
    'post.travelDates': 'Travel dates',
    'post.location': 'Location',
    'post.openPhoto': 'Open photo',
    'post.photoOf': 'of',
    'post.photoViewer': 'Photo viewer',
    'post.closePhoto': 'Close photo viewer',
    'post.nextPhoto': 'Next photo',
    'post.previousPhoto': 'Previous photo',
    'post.readMore': 'Read more',
    'post.readingTime': '8 min read',
    'post.onThisPage': 'On this page',
    'post.loading': 'Loading post...',
    'post.loadError': 'Error loading post:',
    'post.notFound': 'Post not found',
    'post.noCountry': 'No country provided',
    'newsletter.title': 'Stay updated - Subscribe!',
    'newsletter.emailPlaceholder': 'Your email address',
    'newsletter.submit': 'Inform me',
    'page.about': 'About us',
    'page.contact': 'Contact',
    'page.cooperation': 'Cooperation',
    'map.vietnam': 'Vietnam',
    'map.vietnamDescription': 'Coastal routes, lively cities and mountain landscapes.',
    'map.iceland': 'Iceland',
    'map.icelandDescription': 'Land of fire and ice.',
  },
  PL: {
    'nav.home': 'Strona główna',
    'nav.tours': 'Wycieczki',
    'nav.cooperation': 'Współpraca',
    'nav.contact': 'Kontakt',
    'nav.about': 'O nas',
    'nav.back': 'Wstecz',
    'nav.label': 'Nawigacja główna',
    'nav.footerLabel': 'Nawigacja w stopce',
    'nav.openMenu': 'Otwórz menu nawigacyjne',
    'nav.closeMenu': 'Zamknij menu nawigacyjne',
    'brand.tagline': 'Blog podróżniczy',
    'language.label': 'Język',
    'home.heroEyebrow': 'Historie i przewodniki podróżnicze',
    'home.heroTitle': 'Poza utartym szlakiem.',
    'home.heroDescription': 'Poznaj nasze podróże, odkrywaj nowe miejsca i znajdź inspirację na kolejną przygodę.',
    'home.exploreJourneys': 'Odkryj nasze podróże',
    'home.continentsTitle': 'Odkryj kontynenty',
    'home.continentsDescription': 'Poznaj historie i przygody z każdego zakątka świata.',
    'home.featuredTitle': 'Wybrane podróże',
    'home.featuredDescription': 'Kilka podróży, które warto zapamiętać.',
    'home.featuredLoading': 'Ładowanie podróży...',
    'home.featuredError': 'Nie udało się wczytać podróży. Spróbuj ponownie później.',
    'home.featuredEmpty': 'Brak dostępnych podróży.',
    'home.mapTitle': 'Odkryj nasz świat',
    'home.mapDescription': 'Każda czerwona kropka oznacza kraj, który odwiedziliśmy. Wybierz miejsce i poznaj jego historie.',
    'home.viewCountryPosts': 'Zobacz historie',
    'home.recentPosts': 'Najnowsze wpisy',
    'home.recentPostsError': 'Nie udało się wczytać najnowszych wpisów. Spróbuj ponownie później.',
    'home.scrollRecentPosts': 'Przewiń, aby zobaczyć więcej wpisów',
    'home.scrollRecentPostsBack': 'Przewiń, aby zobaczyć wcześniejsze wpisy',
    'home.aboutTitle': 'Historia Deer On Tour',
    'home.aboutDescription': 'Dzielimy się odkrywanymi miejscami, odbytymi podróżami i historiami, dzięki którym każdy cel staje się wyjątkowy.',
    'home.aboutImageAlt': 'Krajobraz z jednej z naszych podróży',
    'home.aboutLink': 'Więcej o nas',
    'posts.countryTitle': 'Wpisy z kraju:',
    'posts.loading': 'Ładowanie wpisów...',
    'posts.loadError': 'Błąd ładowania wpisów:',
    'posts.noCountry': 'Nie podano kraju.',
    'posts.none': 'Nie znaleziono wpisów dla tego kraju.',
    'tours.byContinents': 'Nasze wycieczki według kontynentów:',
    'tours.heroEyebrow': 'Znajdź swoją kolejną podróż',
    'tours.heroDescription': 'Odkrywaj miejsca, poznawaj nasze relacje z podróży i znajdź inspirację na kolejną przygodę.',
    'tours.discoverEyebrow': 'Wybierz kierunek',
    'tours.continentsDescription': 'Przeglądaj nasze podróże według kontynentów i poznawaj historie z odwiedzonych miejsc.',
    'tours.storyCountOne': 'historia',
    'tours.storyCountFew': 'historie',
    'tours.storyCount': 'historii',
    'tours.popularEyebrow': 'Inspiracje podróżnicze',
    'tours.popularTitle': 'Popularne podróże',
    'tours.popularDescription': 'Odkryj wyjątkowe wyprawy i znajdź inspirację na własną podróż.',
    'tours.days': 'dni',
    'tours.noPopularTours': 'Brak dostępnych podróży.',
    'tours.plannerEyebrow': 'Twoja kolejna przygoda',
    'tours.plannerTitle': 'Czas zaplanować kolejną podróż?',
    'tours.plannerDescription': 'Skontaktuj się z nami i znajdź inspirację na swoją następną wyprawę.',
    'tours.plannerAction': 'Napisz do nas',
    'continent.africa': 'Afryka',
    'continent.asia': 'Azja',
    'continent.europe': 'Europa',
    'continent.north america': 'Ameryka Północna',
    'continent.south america': 'Ameryka Południowa',
    'continent.australia': 'Australia',
    'continent.oceania': 'Oceania',
    'continent.antarctica': 'Antarktyda',
    'tours.chooseCountry': 'Wybierz wpisy według kraju',
    'tours.allCountries': 'Wszystkie kraje',
    'tours.postsFrom': 'Wpisy z kontynentu:',
    'tours.noContinent': 'Nie podano kontynentu',
    'tours.flag': 'Flaga:',
    'tours.loading': 'Ładowanie wycieczek...',
    'tours.loadError': 'Błąd ładowania wycieczek:',
    'tours.noCountries': 'Nie znaleziono krajów na tym kontynencie.',
    'tours.noSelectedTours': 'Nie znaleziono wycieczek dla wybranych krajów.',
    'tours.noTours': 'Nie znaleziono wycieczek na tym kontynencie.',
    'post.travelStory': 'Relacja z podróży',
    'post.by': 'autor:',
    'post.tripDetails': 'Szczegóły podróży',
    'post.gallery': 'Galeria',
    'post.duration': 'Czas trwania',
    'post.travelDates': 'Termin podróży',
    'post.location': 'Lokalizacja',
    'post.openPhoto': 'Otwórz zdjęcie',
    'post.photoOf': 'z',
    'post.photoViewer': 'Przeglądarka zdjęć',
    'post.closePhoto': 'Zamknij przeglądarkę zdjęć',
    'post.nextPhoto': 'Następne zdjęcie',
    'post.previousPhoto': 'Poprzednie zdjęcie',
    'post.readMore': 'Czytaj dalej',
    'post.readingTime': '8 min czytania',
    'post.onThisPage': 'Na tej stronie',
    'post.loading': 'Ładowanie wpisu...',
    'post.loadError': 'Błąd ładowania wpisu:',
    'post.notFound': 'Nie znaleziono wpisu',
    'post.noCountry': 'Nie podano kraju',
    'newsletter.title': 'Bądź na bieżąco - zapisz się!',
    'newsletter.emailPlaceholder': 'Twój e-mail...',
    'newsletter.submit': 'Zapisz mnie',
    'page.about': 'O nas',
    'page.contact': 'Kontakt',
    'page.cooperation': 'Współpraca',
    'map.vietnam': 'Wietnam',
    'map.vietnamDescription': 'Nadmorskie trasy, tętniące życiem miasta i górskie krajobrazy.',
    'map.iceland': 'Islandia',
    'map.icelandDescription': 'Kraina ognia i lodu.',
  },
} as const

export type Language = keyof typeof translations
export type TranslationKey = keyof (typeof translations)['EN']

export const continentTranslationKeys: Record<string, TranslationKey> = {
  africa: 'continent.africa',
  asia: 'continent.asia',
  europe: 'continent.europe',
  'north america': 'continent.north america',
  'north-america': 'continent.north america',
  'south america': 'continent.south america',
  'south-america': 'continent.south america',
  australia: 'continent.australia',
  oceania: 'continent.oceania',
  antarctica: 'continent.antarctica',
}